import store from "../index";
import { fetchGet } from "../api/fetch";
import { setAttributes } from "../actions/attributes";
import { get, filter } from "lodash";

export const getAttributeName = (index) => {
  let language = get(store.getState(), ["user", "language"]);
  let attributes = store.getState().attributes;
  if (index && attributes) {
    return get(
      filter(attributes, (a) => a.id === index),
      [0, `name_${language}`]
    );
  }
  return "";
};

export const fetchAttributes = async () => {
  // Fetch attributes
  try {
    let attr = await fetchGet("attributes");
    store.dispatch(setAttributes(attr));
  } catch (e) {
    console.log(e);
  }
};
